<template>
  <div class="row">
    <div class="col-20 std-wrapper intro">
      <router-link
        :to="{name: 'channels-add'}"
        class="add-icon mb-3 d-inline-block"
      >
        <img :src="`${$publicPath}img/channels/add.svg`">
      </router-link>
      <div class="title">
        {{ $t('view-Channels.title') }}
      </div>
      <div class="content">
        {{ $t('view-Channels.intro') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .intro {
    padding-top: 9rem;
    padding-bottom: 9rem;
    text-align: center;
  }
  .add-icon img {
    max-width: 60px;
  }
  .title {
    font-size: 1.563rem;
    font-weight: blod;
  }
  .content {
    display: inline-block;
    font-size: 0.75rem;
    max-width: 290px;
  }
</style>
